// extracted by mini-css-extract-plugin
export default {"scoreBoard":"scoreboard_scoreBoard__yte4t"};